import { useState, useEffect } from 'react';

/**
 * Toast notification hook
 * Provides methods to show success/error messages with auto-dismiss
 */
export const useToast = () => {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    if (toast) {
      const timer = setTimeout(() => setToast(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [toast]);

  const showToast = (message, type = 'error') => {
    setToast({ message, type });
  };

  const showError = (message) => showToast(message, 'error');
  const showSuccess = (message) => showToast(message, 'success');
  const showInfo = (message) => showToast(message, 'info');
  const hideToast = () => setToast(null);

  return { toast, showToast, showError, showSuccess, showInfo, hideToast };
};
